export const fontSize = {
  h1: '5.6rem',
  h2: '4.8rem',
  h3: '3.6rem',
  h4: '3.2rem',
  h5: '2.4rem',
  h6: '2.0rem',
  h7: '1.8rem',
  body1: '1.6rem',
  body2: '1.4rem',
  body3: '1.2rem',
  body4: '1rem',
};
